import { DateTime } from 'luxon';
import React, { createRef } from 'react';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TableView from '../../Components/tableView';
import constants from '../../constants';
import { minMaxFilterEditor, minMaxFilterFunction } from '../../Components/tableViewEditors';


const  AwairSensorsList = () => {
  const { t } = useTranslation();
  const awairTable = createRef<TableView>();

  const columns = [
    {
      title: t('ID'),
      field: 'id',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('SENSOR_ID'),
      field: 'sensorId',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('EMAIL'),
      field: 'mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('REFUND_EMAIL'),
      field: 'refundMail',
      sorter: 'string',
      headerFilter: 'input',
      visible: false
    },
    {
      title: t('CHOISE'),
      field: 'choice',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ADDRESS'),
      field: 'refundAddress',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('REFUNDED'),
      field: 'refunded',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('CREATED_DATE'),
      field: 'createdDate',
      sorter: 'date',
      headerFilter: minMaxFilterEditor,
      headerFilterFunc: minMaxFilterFunction,
      headerFilterLiveFilter: false,
      formatter: (cell: any) => cell.getValue() ? DateTime.fromISO(cell.getValue()).toFormat('dd/LL/yyyy HH:mm') : ''
    },
    {
      title: t('EXPECTED_REFUND_DATE'),
      field: 'expectedRefundDate',
      sorter: 'date',
      headerFilter: minMaxFilterEditor,
      headerFilterFunc: minMaxFilterFunction,
      headerFilterLiveFilter: false,
      formatter: (cell: any) => cell.getValue() ? DateTime.fromISO(cell.getValue()).toFormat('dd/LL/yyyy HH:mm') : ''
    }
  ];

  return <Container>
      <TableView
        t={t}
        id={'awair-list'}
        ref={awairTable}
        api={constants.api.getAwairElementInfo}
        columns={columns}
      />
    </Container>;
};

export default AwairSensorsList;